export interface ConfigLanguage {
  posixCode: string;
  bcp47Code: string;
  name: string;
}

export type LanguageArray = Array<ConfigLanguage>;

export interface Config {
  cdn: string;
  ga_account: string; // eslint-disable-line camelcase
  languages: LanguageArray;
}

export default function loadConfig(): Config {
  const el = document.getElementById('config');

  if (el) {
    let config;

    try {
      config = JSON.parse(el.innerText);
    } catch (_e) {
      throw new TypeError('Unable to parse configuration.');
    }

    __webpack_public_path__ = `${config.cdn}/`; // eslint-disable-line camelcase

    return config;
  }

  throw new Error('Configuration element not found.');
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/lib/config.ts